<template>
  <div class="user-edit">
    <Modal v-if="open" ref="userEdit" :absolute="true" class="mk-modal" @close="close">
      <slot>
        <div class="mk-form">
          <div class="upload-form user">
            <ImageUpload
              :file-limit-size="5"
              :file-type="['image/gif', 'image/png', 'image/jpeg', 'image/bmp', 'image/webp']"
              :class-name="'user-image'"
              :image-path="userData.image"
              :dafault-image-path="'img-user-default/img-user-default-l.png'"
              @updateImgPath="updateImgPath"
            />
            <div class="info">
              <p class="desp">
                {{ $t('COMMON.FILE_LESS_THAN_ONE_MB') }}
              </p>
              <a class="mk-btn mk-btn--secondary" @click="handleUploadImage">
                {{ $t('COMMON.UPLOAD_FILE') }}
              </a>
            </div>
          </div>
          <div class="form-input">
            <label>{{ $t('MEMBER.INFO.NAME') }}</label>
            <input v-model="userData.name" type="text">
          </div>
          <div class="form-input">
            <label>{{ $t('MEMBER.INFO.ACCOUNT') }}</label>
            <input v-model="userData.email" type="text" disabled>
          </div>
          <div class="form-input">
            <label>{{ $t('MEMBER.INFO.PASSWORD') }}</label>
            <div class="input-has-btn">
              <input v-model="userData.password" :disabled="!changePW" type="password">
              <a class="mk-btn mk-btn--secondary" @click="changePW=true, userData.password=''">
                {{ $t('MEMBER.INFO.CHANGE_PASSWORD') }}
              </a>
            </div>
          </div>
          <div v-if="userData.user_detail !== null" class="form-input">
            <label>{{ $t('MEMBER.INFO.DESCRIPTION') }}</label>
            <textarea v-model="userData.user_detail.description" />
          </div>
          <div v-if="userData.user_detail !== null" class="form-input">
            <label>{{ $t('MEMBER.INFO.GENDER') }}</label>
            <div class="mk-radio">
              <input id="radio1" v-model="userData.user_detail.gender" type="radio" value="0" name="reason">
              <label for="radio1">
                {{ $t('MEMBER.INFO.MALE') }}
              </label>
            </div>
            <div class="mk-radio">
              <input id="radio2" v-model="userData.user_detail.gender" type="radio" value="1" name="reason">
              <label for="radio2">
                {{ $t('MEMBER.INFO.FEMALE') }}
              </label>
            </div>
            <div class="mk-radio">
              <input id="radio3" v-model="userData.user_detail.gender" type="radio" value="2" name="reason">
              <label for="radio3">
                {{ $t('MEMBER.INFO.OTHER') }}
              </label>
            </div>
          </div>
          <div class="form-input">
            <label>{{ $t('MEMBER.INFO.BIRTH') }}</label>
            <div class="input-with-text">
              <input v-model="birthday[0]"
                     type="number" min="1" max="9999"
                     @keyup="($event.target.value.length > 3) ? $event.target.parentNode.nextElementSibling.getElementsByTagName('input')[0].focus() : 0"
                     @input="birthday[0] = birthday[0].slice(0,4)"
              ><p>{{ $t('MEMBER.INFO.YEAR') }}</p>
            </div>
            <div class="input-with-text">
              <input v-model="birthday[1]"
                     type="number" min="1" max="99"
                     @keyup="($event.target.value.length > 1) ? $event.target.parentNode.nextElementSibling.getElementsByTagName('input')[0].focus() : 0"
                     @input="birthday[1] = birthday[1].slice(0,2)"
              ><p>{{ $t('MEMBER.INFO.MONTH') }}</p>
            </div>
            <div class="input-with-text">
              <input v-model="birthday[2]"
                     type="number" min="1" max="99"
                     @input="birthday[2] = birthday[2].slice(0,2)"
              ><p>{{ $t('MEMBER.INFO.DAY') }}</p>
            </div>
          </div>
          <div class="form-input form-input-subscribe">
            <div class="mk-checkbox">
              <input id="for-subscribe" v-model="subscribe.edm" type="checkbox">
              <i class="material-icons">
                done
              </i>
              <label for="for-subscribe">
                {{ $t('MEMBER.INFO.SUBSCRIBE') }}
              </label>
            </div>
          </div>
          <div class="btn-group">
            <a :class="{'loading': formSubmit}" class="mk-btn mk-btn--primary" @click="updateUser">
              {{ $t('COMMON.SAVE_CHANGE') }}
            </a>
            <a class="mk-btn mk-btn--secondary" @click="close">
              {{ $t('COMMON.CANCEL') }}
            </a>
          </div>
        </div>
      </slot>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal'
import ImageUpload from '@/components/common/ImageUpload'
import { getLocalStorage } from '@/assets/helpers/UtilHelper'
import MemberService from '@/assets/services/MemberService'

export default {
  name: 'MemberEditModal',
  components: {
    Modal,
    ImageUpload
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    userData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      changePW: false,
      formSubmit: false
    }
  },
  computed: {
    birthday() {
      if (this.userData.user_detail !== null) {
        return this.userData.user_detail.birthday.split('-')
      } else {
        return ''
      }
    }
  },
  watch: {
    open(val) {
      this.formSubmit = false
      this.changePW = false
      this.userData.password = '********'
      this.userData.image = this.userData.avatar
      this.subscribe = this.userData.user_detail.subscribe
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async updateUser() {
      if (this.userData.user_detail) {
        let year = Number(this.birthday[0])
        let month = Number(this.birthday[1])
        let day = Number(this.birthday[2])
        this.userData.user_detail.birthday = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
      }
      if (this.userData.password === '********' || this.userData.password === '') {
        delete this.userData.password
      }
      if (this.subscribe.edm === true) {
        this.userData.user_detail.subscribe.edm = 1
      } else {
        this.userData.user_detail.subscribe.edm = 0
      }
      delete this.userData.image //
      this.userData._method = 'put'
      let dataArray = await this.convertToFormData(this.userData)
      this.userToken = getLocalStorage('token')
      this.formSubmit = true
      await MemberService.updateUser(this.userToken, this.userData.id, dataArray)
      await this.$emit('close', true)
    },
    handleUploadImage(e) {
      document.getElementById('fileInput').click()
    },
    updateImgPath(val) {
      this.userData.avatar = val
    },
    async convertToFormData(dataArray) {
      const bodyFormData = new FormData()
      Object.keys(dataArray).forEach(index => {
        if (Array.isArray(dataArray[index])) {
          dataArray[index].forEach(item => {
            bodyFormData.append(`${index}[]`, item)
          })
        } else if (index !== 'avatar' && dataArray[index] !== null && typeof dataArray[index] === 'object') {
          Object.keys(dataArray[index]).forEach(index2 => {
            if (dataArray[index][index2] === '') {
              dataArray[index][index2] = null
            } else if (dataArray[index][index2] !== null && typeof dataArray[index][index2] === 'object') {
              Object.keys(dataArray[index][index2]).forEach(index3 => {
                bodyFormData.append(`${index}[${index2}][${index3}]`, dataArray[index][index2][index3])
              })
            } else {
              bodyFormData.append(`${index}[${index2}]`, dataArray[index][index2])
            }
          })
        } else {
          bodyFormData.append(index, dataArray[index])
        }
      })
      return bodyFormData
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/component/button.scss';
@import '@/assets/scss/component/radio.scss';
@import '@/assets/scss/component/checkbox.scss';
@import '@/assets/scss/component/form.scss';
@import '@/assets/scss/variables.scss';

@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}

</style>
